export default __webpack_public_path__ + "static/media/s2.b9b1dafd.png";